import { ConfigPrice, defaultPrice } from '../config';

export const isWithYellowSlots = (priceProduct: number, regionId: number): boolean => {
  if (!priceProduct || !regionId) {
    return false;
  }

  const priceLimit = (ConfigPrice[regionId] || defaultPrice) / 4;

  return priceProduct >= priceLimit;
};
